import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import styles from "./styles.module.css";
import CloseIcon from "@mui/icons-material/Close";

const Index = ({ open, setClose, link }) => {
  return (
    <Modal
      open={open}
      onClose={() => setClose(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={styles.modal_wrapper}>
        <Box className={styles.video_box}>
          <Box className={styles.close_btn_wrapper}>
            <Button
              onClick={() => setClose(false)}
              className={styles.close_btn}
            >
              <CloseIcon sx={{ color: "white" }} />
            </Button>
          </Box>
          <video
            src={link}
            controls
            autoPlay
            className={styles.videoPlayer}
            onClick={(e) => e.stopPropagation()}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default Index;
